// THE ESSAY'S PARAGRAPHS IN READING ORDER — a projection of the document blocks (the same projection Essay view renders): root
// units only, grouped by region when regions are active. Used for the focused paragraph workspace's location line and its
// Previous / Next navigation. Reads; never changes anything.
const REGION_ORDER = ["introduction", "body", "conclusion"];
export const REGION_LABEL = { introduction: "Introduction", body: "Body", conclusion: "Conclusion" };

export function orderedParagraphs(doc, items = []) {
  const blocks = (doc && doc.blocks) || [];
  const ids = new Set((items || []).map((i) => i.id));
  const roots = blocks.filter((b) => b.depth === 0 && b.kind !== "group" && ids.has(b.id));
  const regionOf = (b) => (REGION_LABEL[b.region] ? b.region : "body");
  const ordered = doc && doc.regions_active ? REGION_ORDER.flatMap((r) => roots.filter((b) => regionOf(b) === r)) : roots;
  return ordered.map((b, k) => ({ id: b.id, n: k + 1, region: regionOf(b), location: `${REGION_LABEL[regionOf(b)]} · Paragraph ${k + 1}` }));
}

// INCREMENT 4 — WHERE THE WORKING PART SITS IN THE ESSAY: the paragraphs (essay projection) covered by the current compose target —
// the SAME functional unit the backend teaches and maps (`target.included_unit_ids`); the frontend never chooses the unit. Location
// only ("Body · Paragraph 2", "Introduction · Paragraphs 1–2"); it never decides what the part is or where the unit begins/ends.
export function unitLocation(doc, items, includedIds = []) {
  const list = orderedParagraphs(doc, items);
  const ids = new Set(includedIds || []);
  const hit = list.filter((p) => ids.has(p.id));
  if (!hit.length) return null;
  const ns = hit.map((p) => p.n);
  const first = Math.min(...ns), last = Math.max(...ns);
  const region = hit[0].region;
  const span = first === last ? `Paragraph ${first}` : `Paragraphs ${first}\u2013${last}`;
  return { ids: hit.map((p) => p.id), first, last, paragraphs: last - first + 1, count: list.length, region, location: `${REGION_LABEL[region]} · ${span}` };
}

// THE WORKING SPAN (guard): the prose the workspace must show = the authoritative unit's paragraphs, in reading order. Pure projection —
// the frontend never chooses the unit. `ok` is false when a paragraph the unit covers cannot be shown (then the workspace says so; it
// never pretends the one paragraph is the unit).
export function workingSpan(items, ids = []) {
  const byId = new Map((items || []).map((i) => [i.id, i]));
  const parts = (ids || []).map((id) => byId.get(id)).filter(Boolean).map((i) => ({ id: i.id, text: i.text || "", formatting: i.formatting || "" }));   // formatting: presentation only
  return { parts, expected: (ids || []).length, ok: parts.length === (ids || []).length };
}

export function paragraphNav(doc, items, id) {
  const list = orderedParagraphs(doc, items);
  const k = list.findIndex((p) => p.id === id);
  if (k < 0) return null;
  return { ...list[k], prevId: k > 0 ? list[k - 1].id : null, nextId: k < list.length - 1 ? list[k + 1].id : null, count: list.length };
}
